import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  voucherList: [],
  totalItems: 0,
  itemsOnPage: 0,
  voucher: null,
};

const slice = createSlice({
  name: 'voucher',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getVoucherListSuccess(state, action) {
      state.isLoading = false;
      state.voucherList = action.payload.items;
      state.totalItems = action.payload.totalItems;
      state.itemsOnPage = action.payload.itemsOnPage;
    },
    getVoucherByIdSuccess(state, action) {
      state.isLoading = false;
      state.voucher = action.payload;
    },
    addVoucherSuccess(state, action) {
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

export function getVoucherList(params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/admin/vouchers', { params });
      dispatch(slice.actions.getVoucherListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getVoucherById(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/admin/vouchers/${id}`);
      dispatch(slice.actions.getVoucherByIdSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addVoucher(newVoucher) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/api/admin/vouchers', newVoucher);
      dispatch(slice.actions.addVoucherSuccess(response.data));
      return { payload: {} };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  };
}

export function updateVoucher(id, updatedVoucher) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/api/admin/vouchers/${id}`, updatedVoucher);
      dispatch(slice.actions.addVoucherSuccess(response.data));
      return { payload: {} };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || 'An error occurred';
      dispatch(slice.actions.hasError(error));
      return { payload: { error: errorMessage } };
    }
  };
}
